package fr.frux.feature.site.create

import fr.frux.core.common.error.AppError
import fr.frux.shared.content.SiteLimits
import fr.frux.shared.domain.model.PlantingCount
import fr.frux.shared.domain.model.Site
import fr.frux.shared.domain.model.Species

/** Une espèce du lieu, [count] vide tant que la tranche n'est pas choisie. */
data class PlantingLine(
    val species: Species,
    val count: PlantingCount?,
)

/** Règle d'accès déclarée par le créateur. `PRIVATE` ne se choisit pas ici : c'est « chez moi ». */
enum class SiteAccessChoice { OPEN, ASK }

sealed interface CreateSiteSubmission {
    data object Idle : CreateSiteSubmission

    data object Sending : CreateSiteSubmission

    data class Failed(
        val error: AppError,
    ) : CreateSiteSubmission
}

data class CreateSiteState(
    val name: String = "",
    val plantings: List<PlantingLine> = emptyList(),
    val speciesQuery: String = "",
    val speciesResults: List<Species> = emptyList(),
    val access: SiteAccessChoice = SiteAccessChoice.OPEN,
    val managerName: String = "",
    val isHome: Boolean = false,
    val submission: CreateSiteSubmission = CreateSiteSubmission.Idle,
    val exitPrompt: Boolean = false,
) {
    val canSubmit: Boolean
        get() =
            name.trim().isNotEmpty() &&
                name.trim().length <= SiteLimits.NAME_MAX &&
                plantings.isNotEmpty() &&
                plantings.all { it.count != null } &&
                submission != CreateSiteSubmission.Sending

    /** Vrai dès qu'il y a quelque chose à perdre en quittant. */
    val hasInputs: Boolean
        get() = name.isNotBlank() || plantings.isNotEmpty() || managerName.isNotBlank() || isHome
}

sealed interface CreateSiteEvent {
    data class Created(
        val site: Site,
    ) : CreateSiteEvent

    data object Exited : CreateSiteEvent
}
